// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.noData_noDataContainer__lSY1h {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.noData_noDataContainer__lSY1h p {
  color: black;
  margin-top: 10px;
  font-size: 20px;
}

/* .animationContainer {
  height: 450px;
}
@media screen and (max-width: 768px) {
  .noDataContainer {
    height: 400px;
  }
}
@media screen and (max-width: 540px) {
  .noDataContainer {
    height: 350px;
  }
}
@media screen and (max-width: 400px) {
  .noDataContainer {
    height: 320px;
  }
}
@media screen and (max-width: 360px) {
  .noDataContainer {
    height: 200px;
  }
} */`, "",{"version":3,"sources":["webpack://./src/Components/molecules/NoData/noData.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;;;;;;;;;;;;;;;;;;;;GAsBG","sourcesContent":[".noDataContainer {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.noDataContainer p {\n  color: black;\n  margin-top: 10px;\n  font-size: 20px;\n}\n\n/* .animationContainer {\n  height: 450px;\n}\n@media screen and (max-width: 768px) {\n  .noDataContainer {\n    height: 400px;\n  }\n}\n@media screen and (max-width: 540px) {\n  .noDataContainer {\n    height: 350px;\n  }\n}\n@media screen and (max-width: 400px) {\n  .noDataContainer {\n    height: 320px;\n  }\n}\n@media screen and (max-width: 360px) {\n  .noDataContainer {\n    height: 200px;\n  }\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"noDataContainer": `noData_noDataContainer__lSY1h`
};
export default ___CSS_LOADER_EXPORT___;
